import React, { useEffect, useMemo, useState, useCallback } from "react"
import PropTypes from "prop-types"
import { Link, useHistory } from "react-router-dom"
import {} from "react-router"
import { isEmpty } from "lodash"
import "bootstrap/dist/css/bootstrap.min.css"
import TableContainer from "../../../components/Common/TableContainer"
import imageBaseUrl from "../../../helpers/imageBaseUrl"
import { useLocation } from "react-router-dom"
//import components
import Breadcrumbs from "../../../components/Common/Breadcrumb"

import { Name, Email, Phone, Address, Discount, Types } from "./VendorListCol"

//redux
import { useSelector, useDispatch } from "react-redux"

import {
  Col,
  Row,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  Card,
  CardBody,
  DropdownToggle,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"
import DeleteModal from "../../../components/Common/DeleteModal"
import {
  deleteVendor,
  getVendors,
  _setOffset,
  setPage,
  updateVendor,
  _setPage,
  _setQuery,
} from "../../../store/vendor/actions"

function Vendors() {
  const history = useHistory()
  const getRouteName = () => {
    const url = window.location.href
    const parts = url.split("#")

    if (parts.length > 1) {
      const result = parts[1]
      return result
    } else {
      return ""
    }
  }

  //delete vendor
  const [deleteModal, setDeleteModal] = useState(false)
  const [modal, setModal] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [offset, setOffset] = useState(0)
  const [page_size, setPageSize] = useState(10)
  const [vendor, setVendor] = useState([])
  const [query, setQuery] = useState("")

  const dispatch = useDispatch()
  const vendors = useSelector(state => state.vendors.vendor.vendors)
  const loading = useSelector(state => state.vendors.vendor.loading)
  const total_page = useSelector(state => state.vendors.vendor.total_page)
  const {
    vendor: { page_size: p, offset: o, query: q },
  } = useSelector(state => state.vendors)

  // const setPageSize = (a) =>{
  // dispatch(setPage(a))
  // }

  // const _setOffset = (a) =>{
  //   dispatch(setOffset(a))
  // }
  // useEffect(()=>{
  // dispatch(setPage(page_size))
  // dispatch(setOffset(offset))
  // },[page_size,offset])
  useEffect(() => {
    // This function will be called whenever the route changes
    const unlisten = history.listen(location => {
      // You can access the current location and pathname via the location object
      if (
        location.pathname == "/pending_vendors" ||
        location.pathname == "/vendors"
      ) {
        window.location.reload()
      }

      // Perform actions based on the route change here
    })

    // Clean up the listener when the component unmounts
    return () => {
      unlisten() // Unlisten to route changes to prevent memory leaks
    }
  }, [history]) // Include history in the dependency array to re-subscribe when it changes

  useEffect(() => {
    // if (vendors && !vendors.length) {

    const StatusVendor = getRouteName() == "/pending_vendors" ? 0 : 1

    dispatch(
      getVendors({ offset: o, page_size: p, query: q, status: StatusVendor })
    )
    // }
  }, [dispatch, o, p])

  useEffect(() => {
    const StatusVendor = getRouteName() == "/pending_vendors" ? 0 : 1

    if (q) {
      setTimeout(() => {
        dispatch(
          getVendors({
            offset: o,
            page_size: p,
            query: q,
            status: StatusVendor,
          })
        )
      }, 500)
    }
  }, [dispatch, q])

  useEffect(() => {
    if (!isEmpty(vendors)) {
      setIsEdit(false)
    }
  }, [vendors])

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false)
      setVendor(null)
    } else {
      setModal(true)
    }
  }, [modal])

  const handleUserClick = useCallback(
    arg => {
      const vendor = arg
      history.push("/vendors/add", vendor)
      return
    },
    [history]
  )

  const onClickDelete = vendor => {
    setDeleteModal(true)
    setVendor(vendor)
  }

  const handleDeleteUser = () => {
    if (vendor.id) {
      dispatch(deleteVendor(vendor))
    }
  }
  useEffect(() => {
    if (!loading) {
      setDeleteModal(false)
      setModal(false)
    }
  }, [loading])
  const handleUserClicks = () => {
    history.push("/vendors/add")
    // setIsEdit(false)
    // toggle()
  }

  const columns = useMemo(
    () => [
      // {
      //   Header: "Id",
      //   accessor: "checkbox",
      //   disableFilters: true,
      //   filterable: false,
      //   Cell: cellProps => {
      //     return <input type="checkbox" className="selection-input-4" />
      //   },
      // },
      {
        Header: "Logo",
        filterable: true,
        disableFilters: true,
        accessor: cellProps => (
          <React.Fragment>
            {!cellProps.logo ? (
              <div className="avatar-md d-inline-block me-2">
                <div className="avatar-title bg-soft-primary rounded-circle text-primary">
                  <i className="mdi mdi-account-circle m-0"></i>
                </div>
              </div>
            ) : (
              <>
                <img
                  className="avatar-md rounded-circle me-2"
                  src={imageBaseUrl + cellProps?.logo}
                  alt=""
                />
              </>
            )}
          </React.Fragment>
        ),
      },
      {
        Header: "Banner",

        filterable: true,
        disableFilters: true,
        accessor: cellProps => (
          <React.Fragment>
            {!cellProps.banner_img ? (
              <div className="avatar-lg d-inline-block me-2 w-100">
                <div className="avatar-title bg-soft-primary text-primary">
                  <i className="mdi mdi-file-image"></i>
                </div>
              </div>
            ) : (
              <>
                <img
                  className="avatar-lg me-2 w-100"
                  src={imageBaseUrl + cellProps?.banner_img}
                  alt=""
                />
              </>
            )}
          </React.Fragment>
        ),
      },
      {
        Header: "Name",
        accessor: "name",
        filterable: true,
        Cell: cellProps => {
          return <Name {...cellProps} />
        },
      },
      {
        Header: "Email",
        accessor: "email",
        filterable: true,
        Cell: cellProps => {
          return <Email {...cellProps} />
        },
      },
      {
        Header: "Phone",
        accessor: "phone",
        filterable: true,

        Cell: cellProps => {
          return <Phone {...cellProps} />
        },
      },
      {
        Header: "Address",
        accessor: "address",
        filterable: true,

        Cell: cellProps => {
          return <Address {...cellProps} />
        },
      },
      {
        Header: "Discount",
        accessor: "discount",
        filterable: true,

        Cell: cellProps => {
          return <Discount {...cellProps} />
        },
      },
      {
        Header: "Types",
        accessor: "types",
        filterable: true,

        Cell: cellProps => {
          return <Types {...cellProps} />
        },
      },

      // {
      //   Header: "Facebook",
      //   accessor: "fb_link",
      //   filterable: true,

      //   Cell: cellProps => {
      //     return <FacebookLink {...cellProps} />
      //   },
      // },
      // {
      //   Header: "Twitter",
      //   accessor: "twitter_link",
      //   filterable: true,

      //   Cell: cellProps => {
      //     return <TwitterLink {...cellProps} />
      //   },
      // },
      // {
      //   Header: "Instagram",
      //   accessor: "insta_link",
      //   filterable: true,

      //   Cell: cellProps => {
      //     return <InstagramLink {...cellProps} />
      //   },
      // },
      {
        Header: "Featured",
        accessor: "is_feature",
        filterable: true,
        disableFilters: true,

        Cell: cellProps => (
          <div className="form-check form-switch form-switch-lg">
            {cellProps.value == 1 ? (
              <input
                disabled={loading}
                onClick={e =>
                  dispatch(
                    updateVendor({
                      is_feature: 0,
                      id: cellProps.row.original.id,
                      settings_to_remove: JSON.stringify(0),
                      services_to_remove: JSON.stringify(0),
                      types_to_remove: JSON.stringify(0),
                      banner_img: { preview: "preview" },
                      logo: { preview: "preview" },
                    })
                  )
                }
                type="checkbox"
                className="form-check-input"
                id="customSwitchsizelg"
                checked={cellProps.value == 1 ? true : false}
              />
            ) : (
              <input
                disabled={loading}
                onClick={e =>
                  dispatch(
                    updateVendor({
                      is_feature: 1,
                      id: cellProps.row.original.id,
                      settings_to_remove: JSON.stringify(0),
                      services_to_remove: JSON.stringify(0),
                      types_to_remove: JSON.stringify(0),
                      banner_img: { preview: "preview" },
                      logo: { preview: "preview" },
                    })
                  )
                }
                type="checkbox"
                className="form-check-input"
                id="customSwitchsizelg"
                checked={cellProps.value == 1 ? true : false}
              />
            )}
          </div>
        ),
      },
      {
        Header: "Active",
        accessor: "is_active",
        filterable: true,
        disableFilters: true,

        Cell: cellProps => (
          <div className="form-check form-switch form-switch-lg">
            {cellProps.value == 1 ? (
              <input
                disabled={loading}
                onClick={e =>
                  dispatch(
                    updateVendor({
                      is_active: 0,
                      id: cellProps.row.original.id,
                      settings_to_remove: JSON.stringify(0),
                      services_to_remove: JSON.stringify(0),
                      types_to_remove: JSON.stringify(0),
                      banner_img: { preview: "preview" },
                      logo: { preview: "preview" },
                    })
                  )
                }
                type="checkbox"
                className="form-check-input"
                id="customSwitchsizelg"
                checked={cellProps.value == 1 ? true : false}
              />
            ) : (
              <input
                disabled={loading}
                onClick={e =>
                  dispatch(
                    updateVendor({
                      is_active: 1,
                      id: cellProps.row.original.id,
                      settings_to_remove: JSON.stringify(0),
                      services_to_remove: JSON.stringify(0),
                      types_to_remove: JSON.stringify(0),
                      banner_img: { preview: "preview" },
                      logo: { preview: "preview" },
                    })
                  )
                }
                type="checkbox"
                className="form-check-input"
                id="customSwitchsizelg"
                checked={cellProps.value == 1 ? true : false}
              />
            )}
          </div>
        ),
      },
      {
        Header: "Action",
        accessor: "action",
        disableFilters: true,
        Cell: cellProps => {
          return (
            <div className="d-flex gap-3 users">
              <ul className="list-inline font-size-20 contact-links mb-0">
                <li className="list-inline-item">
                  <Link
                    to={"/vendors/edit/" + cellProps.row.original?.id}
                    className="text-primary"
                    // onClick={() => {
                    //   // console.log(cellProps.row)
                    //   const vendors =
                    //   handleUserClick(vendors)
                    // }}
                  >
                    <i className="uil uil-pen font-size-18" id="edittooltip" />
                    <UncontrolledTooltip placement="top" target="edittooltip">
                      Edit
                    </UncontrolledTooltip>
                  </Link>
                </li>
                <li className="list-inline-item">
                  <div
                    className="text-danger"
                    onClick={() => {
                      const vendors = cellProps.row.original
                      onClickDelete(vendors)
                    }}
                  >
                    <i
                      className="uil uil-trash-alt font-size-18"
                      id="deletetooltip"
                    />
                    <UncontrolledTooltip placement="top" target="deletetooltip">
                      Delete
                    </UncontrolledTooltip>
                  </div>
                </li>
                <li className="list-inline-item dropdown">
                  <UncontrolledDropdown>
                    <DropdownToggle
                      tag="a"
                      className="text-muted font-size-18 px-2"
                      caret
                    >
                      <i className="uil uil-ellipsis-v"></i>
                    </DropdownToggle>
                    <DropdownMenu className="dropdown-menu-end">
                      <DropdownItem
                        onClick={() =>
                          history.push(
                            `/vendor/media/${cellProps.row.original.id}`,
                            { vendor_name: cellProps.row.original.name }
                          )
                        }
                      >
                        Posts
                      </DropdownItem>
                      <DropdownItem
                        onClick={() =>
                          history.push(
                            `/vendor/events/${cellProps.row.original.id}`,
                            { vendor_name: cellProps.row.original.name }
                          )
                        }
                      >
                        Events
                      </DropdownItem>
                      <DropdownItem
                        onClick={() =>
                          history.push({
                            pathname: `/vendor/pricing/${cellProps.row.original.id}`,
                            state: {
                              vendor_name: cellProps.row.original.name,
                              types: cellProps.row.original.types,
                            },
                          })
                        }
                      >
                        Pricing
                      </DropdownItem>
                      <DropdownItem
                        onClick={() =>
                          history.push({
                            pathname: `/vendor/file-manager/folders/${cellProps.row.original.id}`,
                            state: {
                              vendor_name: cellProps.row.original.name,
                              types: cellProps.row.original.types,
                            },
                          })
                        }
                      >
                        Gallery
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </li>
              </ul>
            </div>
          )
        },
      },
    ],
    [handleUserClick, loading, page_size]
  )
  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteUser}
        onCloseClick={() => setDeleteModal(false)}
        loading={loading}
      />
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs
            title="MENU"
            breadcrumbItem={
              window.location.href.split("#")[1] === "/vendors"
                ? "Vendors"
                : "Pending vendors"
            }
          />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={vendors}
                    isGlobalFilter={true}
                    isAddUsers={true}
                    isAddTableWithoutBorderStrap={true}
                    handleUserClicks={handleUserClicks}
                    setPage={a => dispatch(_setOffset(a))}
                    page_number={o}
                    total_pages={total_page}
                    _setPageSize={a => dispatch(_setPage(a))}
                    page_size={p}
                    setQuery={q => dispatch(_setQuery(q))}
                    query={q}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader toggle={toggle} tag="h4">
              {!!isEdit ? "Edit User" : "Add Users"}
            </ModalHeader>
            <ModalBody></ModalBody>
          </Modal>
        </div>
      </div>
    </React.Fragment>
  )
}
Vendors.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default Vendors
